module.exports = __webpack_public_path__ + "img/3.21f3a1a8.jpg";